<div [class]="classTabDetailsLeft" [style.margin-top.px]="margintop">
  <div class="mat-elevation-z5">
    <div [style.display]="hideTitle ? 'none' : 'block'" class="tab-details-left-head">
      <h1>{{title}}</h1>
      <dx-tree-view
        #treeview
        [items]="menuItems"
        searchMode="contains"
        (onItemClick)="selectItem($event)"
      ></dx-tree-view>
    </div>
  </div>
</div>
